/**
 * Station Mode (`/station`) — the tablet shop-floor kiosk.
 *
 * Deliberately a TOP-LEVEL route (not under `(workspace)/`) so it renders
 * chromeless — no sidebar or topbar for a worker to wander off into. The root
 * `beforeLoad` still guards it (session + company required), so it's only
 * reachable by a signed-in workspace user. Pin this URL on the station tablet.
 */
import { createFileRoute } from "@tanstack/react-router";
import { StationModePage } from "../../features/station/index.ts";

export const Route = createFileRoute("/station/")({
  component: StationModePage,
});
